import type { calculateCartBreakdown } from "./calculateCartBreakdown";
import type { TaxSettings } from "../zod/taxSchema";
import { getRoundCount, roundDecimalPlaces } from "./formatAmountForStripe";
import { exclusiveRate, inclusiveRate } from "./rateCalc";
import { fixMath } from "./fixMath";

/**
 * Rebuild buyerPaysPlatformFee from cartBreakdownJSON buyerPaysTaxAndFees serviceFee line.
 */
export function calculateBuyerPaysPlatformFee(
    cartBreakdownJSON: ReturnType<typeof calculateCartBreakdown> | null | undefined,
    taxSettingsJSON: TaxSettings | null | undefined,
) {
    const roundCount = getRoundCount(taxSettingsJSON?.currency ?? 'gbp');
    let shownPlatformFee = 0;

    if (taxSettingsJSON?.salesTaxType === 'APPLY_TAX_ON_TOP_OF_PRICES') {
        shownPlatformFee = fixMath.subtract(cartBreakdownJSON?.buyerPaysTaxAndFeesShownFee ?? 0, cartBreakdownJSON?.tax ?? 0) || 0;
    } else if (taxSettingsJSON?.salesTaxType === 'ITEMS_PRICES_ALREADY_INCLUDE_TAXES') {
        shownPlatformFee = cartBreakdownJSON?.buyerPaysTaxAndFeesShownFee ?? 0;
    }

    let buyerPaysPlatformFee = {
        totalWithTax: 0,
        itemTotal: 0,
        tax: 0,
        shownFee: 0
    };
    if (shownPlatformFee === 0) {
        return buyerPaysPlatformFee;
    }
    if (taxSettingsJSON?.salesTaxType === 'APPLY_TAX_ON_TOP_OF_PRICES') {
        const feeTax = exclusiveRate(shownPlatformFee, (taxSettingsJSON?.taxRateForServiceFees ?? 0));
        buyerPaysPlatformFee = {
            totalWithTax: fixMath.add(shownPlatformFee, feeTax),
            itemTotal: shownPlatformFee,
            tax: feeTax,
            shownFee: shownPlatformFee
        };
    } else if (taxSettingsJSON?.salesTaxType === 'ITEMS_PRICES_ALREADY_INCLUDE_TAXES') {
        const feeTax = inclusiveRate(shownPlatformFee, (taxSettingsJSON?.taxRateForServiceFees ?? 0));
        buyerPaysPlatformFee = {
            totalWithTax: shownPlatformFee,
            itemTotal: fixMath.subtract(shownPlatformFee, feeTax),
            tax: feeTax,
            shownFee: shownPlatformFee
        };
    }
    return {
        totalWithTax: roundDecimalPlaces(buyerPaysPlatformFee.totalWithTax, roundCount),
        itemTotal: roundDecimalPlaces(buyerPaysPlatformFee.itemTotal, roundCount),
        tax: roundDecimalPlaces(buyerPaysPlatformFee.tax, roundCount),
        shownFee: roundDecimalPlaces(buyerPaysPlatformFee.shownFee, roundCount),
    }
}

// /**
//  * Customer-paid vs store-covered platform support fee from cartBreakdownJSON.
//  * Uses calculateBuyerPaysPlatformFee (reconstructs from serviceFee line — works for old orders).
//  */
// export function getOrderPlatformSupportFeeParts(
//     cartBreakdownJSON: ReturnType<typeof calculateCartBreakdown> | null | undefined,
//     taxSettingsJSON: TaxSettings | null | undefined,
// ): { customerPaid: number; storeCovered: number } {
//     const roundCount = getRoundCount(taxSettingsJSON?.currency ?? 'gbp');
//     const buyerPaysPlatformFee = calculateBuyerPaysPlatformFee(cartBreakdownJSON, taxSettingsJSON);

//     const customerPaid = buyerPaysPlatformFee.itemTotal;
//     let storeCovered = 0;
//     if (cartBreakdownJSON?.applicationFeeWithTax !== buyerPaysPlatformFee.totalWithTax) {
//         storeCovered = roundDecimalPlaces(
//             Math.max(0, fixMath.subtract(
//                 cartBreakdownJSON?.applicationFeeWithoutTax ?? 0,
//                 buyerPaysPlatformFee.itemTotal)
//             ),
//             roundCount,
//         );
//     }

//     return { customerPaid, storeCovered };
// }
